import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import { API_BASE_URL } from '../../../../../../common/utils/commonUrl'
import http from '../../../../../../common/utils/http'
import { DOWNLOAD_FILE, UPLOAD_FILE } from '../../../../../../common/utils/uploadFileUtil'
import moment from 'moment'

export default {
  data () {
    return {
      newsDetails: null,
      memberInfoForm: {
        definitionId: '',
        memberPhone: "",
        memberName: "",
      },
      memberInfoRules: {
        memberPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '请输入11位手机号' }
        ],
        memberName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    getNewsDetails (id) {
      http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getActivityDefinitionDetails?id=' + id).then(
        res => {
          this.newsDetails = res.data.data
          this.newsDetails.img = this.getImg(res.data.data.codeToFileIds.categoryIcon[0])
        }
      )
    },
    // 获取图片
    getImg (imgCode) {
      let img = `${DOWNLOAD_FILE}${imgCode}?X-Authorization=${localStorage.getItem('token')}`
      return img
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    async submit () {
      console.log(this.memberInfoForm, 'this.memberInfoFormthis.memberInfoForm')
      this.$refs['memberForm'].validate(async (valid) => {
        if (valid) {
          http.post(API_BASE_URL + '/api/wxoa/member/memberBasis/addActivityReservation', this.memberInfoForm)
            .then(
              res => {
                this.$message.success('报名成功!')
                setTimeout(this.$router.go(-1), 3000)
              }
            )
            .catch(
              err => {
                this.$message.error(err.data.message);
              }
            )


        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

  },
  mounted () {
    this.getNewsDetails(this.$route.query.id)
    this.memberInfoForm.definitionId = this.$route.query.id
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page-new/views/veent-details/veent-details.js